document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".product-color-swatch, .swatch");
  const galleryItems = document.querySelectorAll(".media-gallery__item");

  if (swatches.length === 0) return;

  // Normalize customSwatchHexMap keys
  if (window.customSwatchHexMap && !window.normalizedSwatchHexMap) {
    window.normalizedSwatchHexMap = {};
    for (const key in window.customSwatchHexMap) {
      window.normalizedSwatchHexMap[key.toUpperCase()] = window.customSwatchHexMap[key];
    }
  }

  // Apply background colors + tooltip
  swatches.forEach((swatch) => {
    const colorName = swatch.getAttribute("data-color")?.trim() || "";
    const normalized = colorName.toUpperCase();
    let colorValue = "#ccc";

    // Tooltip
    if (colorName) {
      swatch.setAttribute("title", colorName.charAt(0).toUpperCase() + colorName.slice(1));
    }

    // Lookup from normalized map
    if (window.normalizedSwatchHexMap && window.normalizedSwatchHexMap[normalized]) {
      colorValue = window.normalizedSwatchHexMap[normalized];
    } else {
      // Fallback: browser computed color
      const temp = document.createElement("span");
      temp.style.color = colorName;
      document.body.appendChild(temp);
      const rgb = getComputedStyle(temp).color;
      document.body.removeChild(temp);
      const match = rgb.match(/\d+/g);
      if (match) {
        colorValue = "#" + match.slice(0, 3).map((x) =>
          ("0" + parseInt(x).toString(16)).slice(-2)
        ).join("");
      }
    }

    // Apply background
    if (Array.isArray(colorValue) && colorValue.length >= 2) {
      const [c1, c2] = colorValue;
      swatch.style.background = `linear-gradient(to bottom, ${c1} 0%, ${c1} 50%, ${c2} 50%, ${c2} 100%)`;
    } else {
      swatch.style.backgroundColor = colorValue;
    }

    swatch.style.border = "1px solid #000";
  });

  // Gallery filtering function
  function filterGalleryByColor(color) {
    const selectedColor = color.trim().toLowerCase();
    let matchesFound = false;

    galleryItems.forEach((item) => {
      const img = item.querySelector("img");
      if (!img) return;
      const altText = img.alt.trim().toLowerCase();

      if (altText.includes(selectedColor)) {
        item.style.display = "";
        matchesFound = true;
      } else {
        item.style.display = "none";
      }
    });

    if (!matchesFound) {
      galleryItems.forEach((item) => (item.style.display = ""));
    }
  }

  // Click event for swatches
  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const color = swatch.getAttribute("data-color");
      if (color) filterGalleryByColor(color);
    });
  });

  // Set default swatch selection
  const firstSwatch = swatches[0];
  if (firstSwatch) {
    const defaultColor = firstSwatch.getAttribute("data-color");
    const labelFor = firstSwatch.getAttribute("for");
    const radioInput = labelFor ? document.getElementById(labelFor) : null;
    if (radioInput) {
      radioInput.checked = true;
    }
    if (defaultColor) {
      filterGalleryByColor(defaultColor);
    }
  }
});
